export const AccountingIntegrationConstants = {
  QbDescription:
    'QuickBooks is an accounting software that connects with your account to automatically import and categorize transactions. Sync with Axele and easily manage your invoices.',
  syncWithQb: 'Sync with QuickBooks',
};
